import React, {useEffect, useState} from "react"
import {getResource} from "../service/http-service";


export const FieldsOfInterest = ({userInfo, setUserInfo, page, setPage}) => {
    const [array, setArray] = useState([])
    const [isChecked, setIsChecked] = useState(false)
    const [showFieldsError, setShowFieldsError] = useState(false)
    const [checkedElement, setCheckedElement] = useState()

    useEffect (() => {
        getResource('fields_of_interest/get_active').then((data) => {
            console.log( data.data)
            setArray(data.data)
        })
    }, []);

    useEffect(() => {
        const fields = userInfo.fieldOfInterests;
        console.log(fields)
        let entity = {}
        entity.id = checkedElement;
        if(checkedElement){
            if(!userInfo.fieldOfInterests.some(e => e.id === checkedElement)){
                fields.push(entity)
                setUserInfo({...userInfo, fieldOfInterests: fields})
            }else{
                const removedElement = userInfo.fieldOfInterests.filter(el => el.id !== checkedElement)
                setUserInfo({...userInfo, fieldOfInterests: removedElement})
            }
        }},[isChecked])

        return (
            <>
            <h5 className="text-white">*Полиња на интерес</h5>
              <div className="d-flex flex-wrap justify-content-between align-items-center mt-3">
                  {(array.length > 0 && array)&& array.map(item => (<div className="stepper-fields">
                      <input
                          onChange={(e)=> {
                              setCheckedElement(item.id)
                              setIsChecked(!isChecked)
                          }}
                          type="checkbox" className="checkboxes"
                          checked={userInfo.fieldOfInterests.some(e => e.id === item.id)}
                          id={item.id} name={item.name}
                          value={parseInt(item.id)}
                      />
                      <label htmlFor={item.id}>{item.name}</label>
                  </div>))}
                  <div className='text-white text-center float-end w-100'>
                      {showFieldsError && <small>Ве молиме одберете ги вашите полиња на интерес</small>}
                  </div>
                  <div className="form-footer d-flex justify-content-between">
                      <button onClick={() => {
                          setPage(1)
                      }}>Претходна</button>
                      <button onClick={() => {
                          if(userInfo.fieldOfInterests.length > 0){setPage(3)
                          } else {
                              setShowFieldsError(true)
                          }}}>Следна</button>
                  </div>
              </div>
            </>
        )
    }